<style lang="scss">


    .box{
        padding: 40px 10px;
        a{font-size:12px;text-decoration: underline;color:#5078e6;}
        .amount-box {
            height:40px;
            line-height:40px;
            margin-bottom:20px;

        }
        .tab-box{
            margin-top:30px;
            position:relative;
            .problem{
                position:absolute;
                right:0;
                top:0;
                z-index: 100;
            }
        }
        .card-box{

            /*background-color: #f8f8f8;*/
            .header{
                background-color: #f0f2f4;
                line-height:24px;
                overflow: hidden;
                padding:10px;
                .left{float:left;font-size:14px;
                    color:#333333;}
                .right{
                    float:right;
                    font-size:12px;
                    color:#999999;
                }
            }
            .content{ margin-bottom:20px;}

            .content .minicard-list{
                background: #F8F8F8;
                li{
                    float:left;
                    margin:20px 0px 20px 18px;
                    padding-left:30px;
                    height:54*0.75px;
                    background: url("../../assets/images/radio.png") 0 center no-repeat;
                    background-size: 24px;
                    float:left;


                    .minicard{

                        background-color: #ffffff;
                        float:left;
                        position:relative;
                        img{width:190*0.75px;height:54*0.75px;}
                    }
                }
                .active{
                    background: url("../../assets/images/redio_active.png") 0 center no-repeat;
                    background-size: 24px;

                }
            }
            .content .bankcard-list{
                background: #F8F8F8;


                li{
                    float:left;
                    margin:20px 0px 20px 9px;
                    padding:0;
                    .radio{
                        width:24px;
                        height:24px;
                        background: url("../../assets/images/radio.png") 0 0 no-repeat;
                        background-size: 100%;
                        float:left;
                        margin-top:55px;
                        margin-right:2px;
                    }
                    .active{
                        background: url("../../assets/images/redio_active.png") 0 0 no-repeat;
                        background-size: 100%;

                    }
                    .disabled {
                        background-color: #f5f7fa;
                        border-color: #e4e7ed;
                        cursor: not-allowed;
                        border-radius: 12px;
                    }

                    .card{
                        width:222px;
                        height:134px;
                        border: 1px solid #ddd;
                        background-color: #ffffff;
                        float:left;
                        position:relative;
                        .mask{
                            background-color: rgba(221,221,221,0.5);
                            width:100%;
                            position:absolute;
                            left: 0;
                            right: 0;
                            top:0;
                            bottom:0;
                            cursor: not-allowed;

                        }
                        .head{
                            height:37.33px;
                            background:#ffffff;
                            border-bottom: 1px solid #ddd;
                            position:relative;
                            overflow: hidden;
                            img{width:128px;height:36.38px;}
                            span{
                                color:#f68321;
                                position: absolute;top:0;right:0;font-size:12px;line-height:50px;display: inline-block;width:80px;height:40px;background-color: #fff6d7;border-radius:15px;margin-top:-13px;margin-right:-30px;
                                text-align: left;vertical-align: bottom;
                            }
                        }
                        .body{
                            height:45px;
                            border-bottom: 1px solid #ddd;
                            padding:10px;
                            p{
                                line-height:40px;
                                vertical-align: middle;


                            }
                        }
                        .footer{
                            font-size:12px;
                            line-height:30px;
                            padding: 0 10px;
                            color:#999999;
                            .left{float:left;}
                            .right{float:right;}
                        }
                    }

                }
                li.addBtn-box{
                    padding-left:25px;
                    text-align: center;
                    .addBtn{
                        font-family:PingFangSC-Regular;
                        font-size:14px;
                        color:#5078e6;
                        text-decoration: underline;
                        display: inline-block;
                        height:124px;
                        line-height:124px;
                        padding-left:30px;
                        background: url("../../assets/images/icon-add.png") 0 center no-repeat;
                        background-size: 24px 24px;


                    }
                }

            }
            .more-box{
                padding:40px;
            }
        }
        .tips{
            font-size:12px;
            margin-top:50px;
        }





    }
    .wait-yanmi{
        text-align: center;
        img{
            width:402px;
            height:85px;
        }
        h4{
            font-size:18px;
            color:#333333;
            font-weight: bold;
            margin:10px;
        }
        p{
            span{color:orange;}
        }
    }
    .btn-box{
        text-align: center;
        .el-button--medium{
            margin:30px 20px;
            width:200px;font-family: microsoft yahei;font-size:16px;height:44px;

        }
        .el-button--primary.is-plain{
            background: #ffffff;
        }
        .el-button--primary.is-plain:focus,.el-button--primary.is-plain:hover {
            background: #409EFF;
            border-color: #409EFF;
            color: #fff
        }

    }
    .el-button--medium{
        width:280px;font-family: microsoft yahei;font-size:16px;height:44px;
    }

    .el-dialog__body{
        border-top: 1px solid #ddd;

    }


</style>

<template>
    <div>
        <gf-page-title  title="账户充值" />
        <div class="box clearfix">
            <div class="amount-box">
                <el-form :inline="true" ref="amountForm" :model="amountFormData" :rules="rules">
                    <el-form-item label="充值金额：" prop="payAmount">
                        <el-input class="cus" v-model="amountFormData.payAmount"> </el-input>
                    </el-form-item>
                    <el-form-item label="元">
                    </el-form-item>

                </el-form>
            </div>
            <div class="clearfix"></div>


            <!--银行列表模块-->
            <bank-list />


            <div class="clearfix"></div>
            <el-button size="medium" type="primary" @click="recharge();doLog('PC支付-充值快捷支付-立即支付')" :disabled="btnLoading" v-loading="btnLoading" >立即支付</el-button>
            <p class="tips">
                <span>温馨提示</span> <br>
                1.为了您能顺利完成支付，请使用在银行办理的一类账户进行支付 <br>
                2.借款用户充值的金额仅可用于还款 <br>
                3.所有账户可用金额将由第三方平台存管 <br>
                4.请注意您的网银支付上限 <br>
                5.如充值金额没有及时到账，请您联系客服：400-811-2288 <br>
            </p>


        </div>
        <el-dialog
                title="存管信息提示"
                :visible.sync="dialogVisible"
                width="750px"
                :close-on-click-modal="false"
                top="30vh"

        >
            <div class="wait-yanmi">
                <img src="../../assets/images/yrd_gf.jpg" alt="">
                <h4 v-if="yanmiStatus==0">

                    您是否已在广发银行页面完成交易验证？

                </h4>
                <h4 v-if="yanmiStatus == -1">

                    查询到您在广发银行页面交易验证操作失败，请重试。


                </h4>

            </div>
            <div class="btn-box">
                <el-button v-if="yanmiStatus == 0" size="medium" type="primary" @click="checkResultHeng2();doLog('PC支付流程-是否完成验证-已完成验证')"  >已完成验证</el-button>
                <el-button v-if="yanmiStatus == -1" size="medium" type="primary" @click="goYanmi();doLog('PC支付流程-是否完成验证-重新验证')"  >重新验证</el-button>
                <el-button type="primary" size="medium" @click="goZfwt();doLog('PC支付流程-是否完成验证-支付遇到问题')" plain>支付遇到问题</el-button>
            </div>

        </el-dialog>
        <el-dialog
                title="存管信息提示"
                :visible.sync="dialogGFVisible"
                width="600px"
                :close-on-click-modal="false"
                top="30vh"

        >
            <div class="wait-yanmi">
                <img src="../../assets/images/yrd_gf.jpg" alt="">
                <h4>为了您的后续操作 <br>需跳转至广发银行页面，完成存管账户后续操作</h4>


            </div>
            <div class="btn-box">
                <el-button size="medium" type="primary" @click="goYanmi"  >确定</el-button>
            </div>

        </el-dialog>
        <el-dialog
                title="正在充值"
                :visible.sync="dialogChargingVisible"
                width="600px"
                :close-on-click-modal="false"
                top="30vh"

        >
            <div class="wait-yanmi">
                <h4>请您在新打开的网上银行页面上完成付款</h4>
                <p>付款完成前请不要关闭窗口，充值完成后请根据您的情况点击下面的按钮。</p>



            </div>
            <div class="btn-box">
                <el-button size="medium" type="primary" @click="queryPayResult"  >已完成支付</el-button>
                <el-button type="primary" size="medium" @click="goZfwt" plain>支付遇到问题</el-button>
            </div>

        </el-dialog>

    </div>
</template>
<script>
    import GfPageTitle from '../../components/gfPageTitle'
    import bankList from '../../components/bankList'
	export default {
		components:{GfPageTitle,bankList},

		data() {
		    return {
		    	orderId:'',
                payId:'',
				dialogVisible:false,
				dialogGFVisible:false,
				dialogChargingVisible:false,
                yanmiUrl:'',
				queryTimes:0,
                payData:{},

                btnLoading:false,
				baseUrl:process.env.BASE_URL,
				amountFormData:{payAmount:'',},
				rules:{
					payAmount: { required: true,pattern:/^([1-9][\d]{0,7}|0)(\.[\d]{1,2})?$/, message: '请输入正确的金额', trigger: 'blur' },


				},
				rechargeBankIndex:'',
                bizId:'',
                yanmiStatus:0,   //0未验密； 1验密成功  ； -1验密失败



			}
        },

        computed:{


            banksData(){
				return  this.$store.state.payBanksData
            }
        },

        methods:{
			getAccountUrl(){
				this.btnLoading = true

				this.$axios({
					method: 'post',
					url: '/user/supervise/account',
					data:{returnUrl:window.location.protocol+'//'+window.location.host+'/pcloan/user/recharge'}
				}).then( (res) =>{
					this.btnLoading = false
					if(res.result){
						this.$router.push({name:'guangfaRedirect',query:{redirect:encodeURIComponent(res.data.url),toCreate:'1'}})

					}else{
						this.$alert(res.message, '提示', {
							confirmButtonText: '确定',
						});
					}


				}).catch((err)=> {
					this.btnLoading = false
					console.warn(err)
				})
			},
			getDepositInfo(){
				this.btnLoading = true
				this.$axios({
					method: 'get',
					url: '/user/supervise/status',

				}).then( (res) =>{
					console.log(res)
					this.btnLoading = false

					if(res.data.superviseStatus == '1'){//已开户
						this.amtCheck()
					}else{
						this.getAccountUrl()
						this.doLog('PC支付流程-广发开户')

					}



				}).catch((err)=> {
					this.btnLoading = false
					console.warn(err)
				})
			},
			recharge(){
				_hmt.push(['_trackEvent', '点击事件', '账户首页-去充值-立即支付']);

				this.btnLoading=true
				this.$axios({
					method: 'get',
					url: '/recharge/canRecharge'
				}).then( (res) =>{
					this.btnLoading=false
					if(res.result){
						this.getDepositInfo()


					}else{
						this.$alert(res.message, '提示', {
							confirmButtonText: '确定',
						});
						this.doLog('PC支付-充值快捷支付-'+res.message)

					}
				}).catch( (err) =>{
					console.warn(err)
					this.btnLoading=false
					this.$alert('出错了，请稍后再试', '提示', {
						confirmButtonText: '确定',
					});
				})

			},
			goZfwt(){
				window.open("https://www.yirendai.com/support/others/wyfw/","_blank");
            },


			amtCheck(){

				this.$refs['amountForm'].validate().then(()=>{
					let payAmount = this.amountFormData.payAmount
					if(payAmount<1){
						this.$alert('您输入的充值金额最少应为1元', '提示', {
							confirmButtonText: '确定',
						});
						return
                    }
					if(this.banksData.activeTabName == 'kj'){
						if(!this.banksData.kjBindCardId){
							this.$alert('请选择银行卡', '提示', {
								confirmButtonText: '确定',
							});
							return
						}
						this.btnLoading=true

						this.quickPayRequest()
					}else{
						if(!this.banksData.wybankid){
							this.$alert('请选择银行卡', '提示', {
								confirmButtonText: '确定',
							});
							return
						}
						this.btnLoading=true

						this.bankPayRequest()
                    }



				}).catch((err)=>{
					console.log(err)
				})
            },
			quickPayRequest(){
				let totalPayAmt =this.amountFormData.payAmount
                let  toPayAmt = totalPayAmt
				let bindCardId = this.banksData.kjBindCardId
                let payChannel = 'RECHARGE'
				this.axios({
                    url:'/repay2/quickPayRequest',method:'post',
                    data:{toPayAmt,totalPayAmt,bindCardId,payChannel}
				}).then( (res) =>{
					console.log(res)
					this.btnLoading=false

					if(res.result){
                        this.payId=res.data.payId
						this.checkUrl(this.payId)

					}else{
						this.$alert(res.message, '提示', {
							confirmButtonText: '确定',
						});
						this.btnLoading=false
                        this.doLog('PC支付流程-'+res.message)

					}
				}).catch( (err)=> {
					alert('系统错误,请稍后再试')
					this.btnLoading=false

					console.warn(err)
				})
            },
			bankPayRequest(){
				let totalPayAmt =this.amountFormData.payAmount

				let bankId =this.banksData.wybankid
				let payChannel = 'RECHARGE'
				let callbackUrl = window.location.protocol+'//'+window.location.host+'/pcloan/bankRechargeStatus'

				this.axios({
					url:'/repay2/bankPayRequest',method:'post',
					data:{totalPayAmt,bankId,payChannel,callbackUrl}
				}).then( (res) =>{
					console.log(res)
					this.btnLoading=false

					if(res.result){
						this.payId=res.data.payId
						this.checkUrl(this.payId)

					}else{
						this.$alert(res.message, '提示', {
							confirmButtonText: '确定',
						});
						this.btnLoading=false

					}
				}).catch( (err)=> {
					alert('系统错误,请稍后再试')
					this.btnLoading=false

					console.warn(err)
				})
			},
			checkUrl(payId){
				this.$axios({
					method: 'post',
					url: '/user/supervise/password/HuiMinCheckUrl',
                    data:{payId,returnUrl:window.location.protocol+'//'+window.location.host+'/pcloan/testDensity'}
				}).then( (res) =>{
					console.log(res)
					this.btnLoading=false

					if(res.result){
						this.yanmiUrl=res.data.url
                        this.dialogGFVisible=true
                        this.bizId=res.data.bizId
						this.doLog('PC支付流程-跳转广发弹窗')

					}else{
						this.$alert(res.message, '提示', {
							confirmButtonText: '确定',
						});
						this.btnLoading=false

					}
				}).catch(function (err) {
					console.warn(err)
					this.btnLoading=false

				})
			},
			getBankPayUrl(){

				this.$axios({
					method: 'post',
					url: '/repay2/getBankPayUrl',
                    data:{payId:this.payId}
				}).then( (res) =>{
					console.log(res)
					this.btnLoading=false

					if(res.result){
						//去往网银支付，打开新页面
                        this.dialogGFVisible=false
                        this.dialogChargingVisible=true
						window.open(res.data.payUrl,'_blank')



					}else{
						this.$alert(res.message, '提示', {
							confirmButtonText: '确定',
						});
						this.btnLoading=false

					}
				}).catch(function (err) {
					console.warn(err)
					this.btnLoading=false

				})
			},

            goYanmi(){

				//todo 验密回调地址
				window.open(this.yanmiUrl,'_blank')
                this.yanmiStatus=0;
				this.dialogVisible=true
            },
			checkResult(){


            },
			checkResultHeng2(){
				this.$axios({
					method: 'get',
					url: '/user/supervise/password/checkHuiMinResult?bizId='+this.bizId
				}).then( (res) =>{
					console.log('验密结果',res)

					if(res.result){
						//验密成功
						this.yanmiStatus = 1
						if(this.banksData.activeTabName == 'kj'){
							//到快捷支付提交页面
							let rechargeBindCardId =this.banksData.kjBindCardId
							let bank =this.banksData.kjBanks.find((b)=>{
								return b.bindCardId == rechargeBindCardId
							})
							let bankEnName = bank['bankEnShortName']
							let bankAccountNo = bank['bankCardNo']
							let payAmount = this.amountFormData.payAmount
							let bizId=this.bizId
							const data = {payAmount,bankEnName,bankAccountNo,rechargeBindCardId,bizId}
							window.localStorage.setItem(this.payId,JSON.stringify(data))


							this.$router.push({name:'rechargeSubmit2',params:{payId:this.payId}})
                        }else{
							//网银支付
                            this.getBankPayUrl()

                        }



					}else{
						this.yanmiStatus = -1

						this.$alert(res.message, '提示', {
							confirmButtonText: '确定',
						});
						this.doLog('PC支付流程-验密失败-支付遇到问题')
					}
				}).catch( (err)=> {
					console.warn(err)
					this.yanmiStatus = -1


				})
			},
			queryPayResult(){
				let payId = this.payId
				console.log('payId',payId)
				this.$axios({
					method: 'post',
					url: '/repay2/queryPayResult',
					data:{payId}
				}).then( (res) =>{

					if(res.result){
						if(res.data.status == 'DEALING' ||res.data.status == 'UNPAY'){
							this.queryPayResult()

						}
						if(res.data.status == 'OK'){
                            const payData ={status:true,rechargeAmount:this.amountFormData.payAmount}

							localStorage.setItem(payId,JSON.stringify(payData))
							//todo 去新充值成功页
							this.$router.push({name:'rechargeResult2', params: { payId }})
							_hmt.push(['_trackEvent', '充值成功事件', '账户首页-去充值-充值成功']);
                        }
						if(res.data.status == ' FAIL'){
							// todo 去新还款失败页
							this.$router.push({name:'rechargeResult2', params: { payId }})
						}

					}else{
						this.$alert(res.message, '提示', {
							confirmButtonText: '确定',
						});

					}

				}).catch(function (err) {
					console.warn(err)
				})
			}




        },
        created(){

        }
    }
</script>
